var _defs, _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _g4, _path9, _path10, _path11, _path12, _path13, _g5, _path14, _g6, _path15, _path16, _path17, _path18, _path19, _path20, _g7, _path21, _g8, _path22, _path23, _path24, _path25, _path26, _path27, _g9, _path28, _g10, _path29, _path30, _path31, _path32, _path33, _g11, _path34, _g12, _path35, _path36, _g13, _path37, _g14, _g15, _g16, _path38, _g17, _g18, _path39, _path40, _path41, _path42, _path43, _path44, _g19, _g20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImplicitExercise = function SvgImplicitExercise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 116"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h38.298v90.324H0z",
    "data-name": "Rectangle 33358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.709v7.871H0z",
    "data-name": "Rectangle 33338"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h11.68v11.925H0z",
    "data-name": "Rectangle 33339"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.981v50.843H0z",
    "data-name": "Rectangle 33341"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4.983v28.346H0z",
    "data-name": "Rectangle 33342"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.175v1.815H0z",
    "data-name": "Rectangle 33343"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.177v1.815H0z",
    "data-name": "Rectangle 33344"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.465v28.813H0z",
    "data-name": "Rectangle 33349"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.877v1.838H0z",
    "data-name": "Rectangle 33350"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h21.404v6.388H0z",
    "data-name": "Rectangle 33351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.161v.895H0z",
    "data-name": "Rectangle 33352"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h10.508v10.092H0z",
    "data-name": "Rectangle 33353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h13.948v24.649H0z",
    "data-name": "Rectangle 33354"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h6.7v17.785H0z",
    "data-name": "Rectangle 33355"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "implicit_exercise_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20.67v10.095H0z",
    "data-name": "Rectangle 33356"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58174",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M67.5 4c28.995 0 48.272 25.072 48.272 56S96.495 116 67.5 116c-18.122 0-28.121-6.905-37.691-22.017C24.283 85.261 15 71.6 15 60 15 29.072 38.505 4 67.5 4",
    "data-name": "Path 51087"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58112"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__a)",
    "data-name": "Group 58171",
    transform: "translate(49.105 25.676)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58170"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__a)",
    "data-name": "Group 58169"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#152429",
    d: "M10.34 40.798c.672-.343.706.575 1.989 1.449 3.35 2.282-.189 14.563-2.428 22.908-1.16 4.324-3.264 6.842-5.5 7.124-1.916.242-4.889-1.587-4.262-5.351 1.018-6.106 2.774-11.044 4.479-17.135 1.055-3.77 2.866-7.539 5.717-8.994",
    "data-name": "Path 51089"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0a47c",
    d: "M15.274 40.276a3.57 3.57 0 0 0 4.276 3.029 3.3 3.3 0 0 0 2.957-4.046l-1.465-10.41-6.813 4.036 1.04 7.391",
    "data-name": "Path 51090"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58114",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58113"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__b)",
    "data-name": "Group 58112",
    transform: "translate(14.336 29.764)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M7.709 6.402A8.97 8.97 0 0 1 .498 7.574l-.5-3.537L6.806 0l.9 6.4",
    "data-name": "Path 51091"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8eaef",
    d: "M8.659 43.404s4.653-4.737 5.964-5.323l.142 1.01c.3 2.1 1.174 4.224 2.851 3.988 1.724-.243 5.276-2.991 4.98-5.09l-.142-1.01a3.74 3.74 0 0 1 1.913.658l5.746 44.209a54 54 0 0 1-9.934-.255c-5.455-.529-7.171-2.881-7.171-2.881Z",
    "data-name": "Path 51092"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#aa0e0e",
    d: "m17.055 48.521-1.621-3.885 2.013-1.613 2.224 1.846-1.368 3.591s.254 6.665.807 12.751c.534 5.877 1.053 14.067 1.053 14.067l-2.7 4.46-1.96-5.305s.372-7.489.489-10.721c.343-9.459 1.057-15.191 1.057-15.191",
    "data-name": "Path 51093"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58117",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58116"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__c)",
    "data-name": "Group 58115",
    transform: "translate(12.97 37.148)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f363d",
    d: "m0 2.867 1.872-1.81L4.44 5.983 9.381 0l2.3 1.224-3.875 10.049-3.225-4.732-2.966 5.387Z",
    "data-name": "Path 51094"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.052 39.246 1.8-1.8 2.612 5.6-2.835 5.33Z",
    "data-name": "Path 51095"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.364 37.655-2.232-1.233-4.668 6.626 3.273 4.527Z",
    "data-name": "Path 51096"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f363d",
    d: "M37.583 57.878a157 157 0 0 1 .213 27.593c-2 1.962-12.338 4.657-16.406 4.853 0 0 .1-12.057 0-23.672-.024-2.75-.278-5.693-.231-7.457a193 193 0 0 1 2.414-21.763 13.4 13.4 0 0 1 2.391.4c2.866.815 9.74 1.648 11.619 20.049",
    "data-name": "Path 51097"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58123",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58122"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__d)",
    "data-name": "Group 58121",
    transform: "translate(6.947 38.886)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58120",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58119"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__d)",
    "data-name": "Group 58118"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "M1.159 24.76c3.525 17.223 1.006 17.473 1.006 17.473 0 2.413 1.419 7.445 4.015 8.61 0 0 2.364-2.684 1.675-19.541-.114-2.775-.768-10.009-.788-11.488C7.03 17.232 6.575 6.823 7.016 0a8 8 0 0 0-1.462.842c-2.44 1.48-7.943 6.587-4.4 23.918",
    "data-name": "Path 51098"
  })))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58126",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58125"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__e)",
    "data-name": "Group 58124",
    transform: "translate(8.599 38.876)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "m1.819 2.102 3.164-2.1s-.425 4.214-1.025 10.573c-.5 5.407.951 17.771.951 17.771L.187 13.557 2.4 11.069 0 9.606Z",
    "data-name": "Path 51099"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f363d",
    d: "M7.495 65.011c3.068 12.7 2 14.611.4 16.358-.622.678 1.374 6.573 4.274 8.071a62.9 62.9 0 0 0 1.344-19.656c-.283-2.761-.311-5-.438-6.475-.942-10.972.835-24.516.835-24.516a17 17 0 0 0-2.189 1.135c-2.44 1.48-8.372 7.911-4.224 25.082",
    "data-name": "Path 51100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "m10.372 40.529 3.638-2.222s-.429 4.216-1.023 10.575c-.5 5.408.523 18.34.523 18.34L9.217 51.864l2.213-2.488-2.4-1.463Z",
    "data-name": "Path 51101"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "M11.686 69.858a.688.688 0 1 0 .585-.777.687.687 0 0 0-.585.777",
    "data-name": "Path 51102"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "M11.979 77.318a.588.588 0 1 0 .62-.652.64.64 0 0 0-.62.652",
    "data-name": "Path 51103"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M5.614 26.885a2.024 2.024 0 0 0-.564-4.009l-1.584.224a2.024 2.024 0 0 0 .56 4.009Z",
    "data-name": "Path 51104"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58129",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58128"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__f)",
    "data-name": "Group 58127",
    transform: "translate(2.951 24.084)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M2.491 1.585A.8.8 0 0 0 2.269.008L.682.231a.8.8 0 0 0 .222 1.577Z",
    "data-name": "Path 51105"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M26.856 23.896a2.024 2.024 0 1 0-.564-4.009l-1.586.223a2.024 2.024 0 1 0 .564 4.009Z",
    "data-name": "Path 51106"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58132",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58131"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__g)",
    "data-name": "Group 58130",
    transform: "translate(24.192 21.096)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M2.493 1.584A.8.8 0 0 0 2.271.008L.685.231a.8.8 0 0 0 .221 1.576Z",
    "data-name": "Path 51107"
  }))))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc49a",
    d: "M12.682 5.894c-5.685.8-9.78 5.1-8.98 10.786l1.85 13.179c.8 5.684 6.181 10.53 11.867 9.73s9.522-6.942 8.722-12.627l-1.85-13.18c-.8-5.686-5.924-8.689-11.609-7.888",
    "data-name": "Path 51108"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M14.076 26.622a3.1 3.1 0 0 0 1.5.064 4.3 4.3 0 0 0 1.45-.458 1.32 1.32 0 0 1-1.219 1.479 1.363 1.363 0 0 1-1.731-1.084",
    "data-name": "Path 51109"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "m17.124 17.077 3.166 1.169a.43.43 0 1 0 .3-.807l-3.166-1.169a.43.43 0 1 0-.3.807",
    "data-name": "Path 51110"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "M10.537 19.938a.43.43 0 0 0-.406-.744l-3.274 1.113a.43.43 0 0 0 .277.814l3.275-1.113a.4.4 0 0 0 .129-.071",
    "data-name": "Path 51111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#774a07",
    d: "M2.265 11.721a9.62 9.62 0 0 1 3.094-8.035 13.17 13.17 0 0 1 5.665-2.9c-.372.754-1 2.074-.618 1.6C11.458 1.071 14.179.327 15.32.063a9 9 0 0 1 2.3-.006c.016 1.266-1.857 2.63-.924 2.508C18.051 2.391 19.229.579 19.48.747a10.83 10.83 0 0 1 4.834 8.625c.248 2.5.875 10.583.875 10.583s-.866-4.664-1.111-6.416c-.454-3.261-3.21-5.885-5.7-4.193a9.2 9.2 0 0 1-5.788 1.715c-4.2.115-5.222.061-6.238.1-2.233.089-2.876 2.239-2.611 4.157.18 1.277.781 7.113.781 7.113s-1.812-7.349-2.257-10.71",
    "data-name": "Path 51112"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M5.614 26.885a2.024 2.024 0 0 0-.564-4.009l-1.584.224a2.024 2.024 0 0 0 .56 4.009Z",
    "data-name": "Path 51113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58135",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58134"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__f)",
    "data-name": "Group 58133",
    transform: "translate(2.951 24.084)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M2.491 1.585A.8.8 0 0 0 2.269.008L.682.231a.8.8 0 0 0 .222 1.577Z",
    "data-name": "Path 51114"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M26.856 23.896a2.024 2.024 0 1 0-.564-4.009l-1.586.223a2.024 2.024 0 1 0 .564 4.009Z",
    "data-name": "Path 51115"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58138",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58137"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__g)",
    "data-name": "Group 58136",
    transform: "translate(24.192 21.096)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M2.493 1.584A.8.8 0 0 0 2.271.008L.685.231a.8.8 0 0 0 .221 1.576Z",
    "data-name": "Path 51116"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc49a",
    d: "M12.682 5.894c-5.685.8-9.78 5.1-8.98 10.786l1.85 13.179c.8 5.684 6.181 10.53 11.867 9.73s9.522-6.942 8.722-12.627l-1.85-13.18c-.8-5.686-5.924-8.689-11.609-7.888",
    "data-name": "Path 51117"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M14.076 26.622a3.1 3.1 0 0 0 1.5.064 4.3 4.3 0 0 0 1.45-.458 1.32 1.32 0 0 1-1.219 1.479 1.363 1.363 0 0 1-1.731-1.084",
    "data-name": "Path 51118"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "m17.124 17.077 3.166 1.169a.43.43 0 1 0 .3-.807l-3.166-1.169a.43.43 0 1 0-.3.807",
    "data-name": "Path 51119"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "M10.537 19.938a.43.43 0 0 0-.406-.744l-3.274 1.113a.43.43 0 0 0 .277.814l3.275-1.113a.4.4 0 0 0 .129-.071",
    "data-name": "Path 51120"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#774a07",
    d: "M2.265 11.721a9.62 9.62 0 0 1 3.094-8.035 13.17 13.17 0 0 1 5.665-2.9c-.372.754-1 2.074-.618 1.6C11.458 1.071 14.179.327 15.32.063a9 9 0 0 1 2.3-.006c.016 1.266-1.857 2.63-.924 2.508C18.051 2.391 19.229.579 19.48.747a10.83 10.83 0 0 1 4.834 8.625c.248 2.5.875 10.583.875 10.583s-.866-4.664-1.111-6.416c-.454-3.261-3.21-5.885-5.7-4.193a9.2 9.2 0 0 1-5.788 1.715c-4.2.115-5.222.061-6.238.1-2.233.089-2.876 2.239-2.611 4.157.18 1.277.781 7.113.781 7.113s-1.812-7.349-2.257-10.71",
    "data-name": "Path 51121"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M5.614 26.885a2.024 2.024 0 0 0-.564-4.009l-1.584.224a2.024 2.024 0 0 0 .56 4.009Z",
    "data-name": "Path 51122"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58141",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58140"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__f)",
    "data-name": "Group 58139",
    transform: "translate(2.951 24.084)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M2.491 1.585A.8.8 0 0 0 2.269.008L.682.231a.8.8 0 0 0 .222 1.577Z",
    "data-name": "Path 51123"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#eaae86",
    d: "M26.856 23.896a2.024 2.024 0 1 0-.564-4.009l-1.586.223a2.024 2.024 0 1 0 .564 4.009Z",
    "data-name": "Path 51124"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58144",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58143"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__g)",
    "data-name": "Group 58142",
    transform: "translate(24.192 21.096)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2e6dc",
    d: "M2.493 1.584A.8.8 0 0 0 2.271.008L.685.231a.8.8 0 0 0 .221 1.576Z",
    "data-name": "Path 51125"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc49a",
    d: "M12.682 5.894c-5.685.8-9.78 5.1-8.98 10.786l1.85 13.179c.8 5.684 6.181 10.53 11.867 9.73s9.522-6.942 8.722-12.627l-1.85-13.18c-.8-5.686-5.924-8.689-11.609-7.888",
    "data-name": "Path 51126"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M14.076 26.622a3.1 3.1 0 0 0 1.5.064 4.3 4.3 0 0 0 1.45-.458 1.32 1.32 0 0 1-1.219 1.479 1.363 1.363 0 0 1-1.731-1.084",
    "data-name": "Path 51127"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "m17.124 17.077 3.166 1.169a.43.43 0 1 0 .3-.807l-3.166-1.169a.43.43 0 1 0-.3.807",
    "data-name": "Path 51128"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2615",
    d: "M10.537 19.938a.43.43 0 0 0-.406-.744l-3.274 1.113a.43.43 0 0 0 .277.814l3.275-1.113a.4.4 0 0 0 .129-.071",
    "data-name": "Path 51129"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#774a07",
    d: "M2.265 11.721a9.62 9.62 0 0 1 3.094-8.035 13.17 13.17 0 0 1 5.665-2.9c-.372.754-1 2.074-.618 1.6C11.458 1.071 14.179.327 15.32.063a9 9 0 0 1 2.3-.006c.016 1.266-1.857 2.63-.924 2.508C18.051 2.391 19.229.579 19.48.747a10.83 10.83 0 0 1 4.834 8.625c.248 2.5.875 10.583.875 10.583s-.866-4.664-1.111-6.416c-.454-3.261-3.21-5.885-5.7-4.193a9.2 9.2 0 0 1-5.788 1.715c-4.2.115-5.222.061-6.238.1-2.233.089-2.876 2.239-2.611 4.157.18 1.277.781 7.113.781 7.113s-1.812-7.349-2.257-10.71",
    "data-name": "Path 51130"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58147",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58146"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__h)",
    "data-name": "Group 58145",
    transform: "translate(21.572 37.352)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "M5.466.831 2.242 0a53.6 53.6 0 0 0-2.2 13.9c-.146 7.2.159 14.909.159 14.909L4.979 13.6l-2.884-2.721 3.286-.983Z",
    "data-name": "Path 51131"
  }))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#334f57",
    d: "m27.093 38.004-3.753-1.009a53.6 53.6 0 0 0-2.2 13.9c-.146 7.2.634 15.267.634 15.267l4.3-15.566-2.882-2.729 3.286-.982Z",
    "data-name": "Path 51132"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58150",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58149"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__i)",
    "data-name": "Group 58148",
    transform: "translate(13.31 30.038)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3673a",
    d: "M.305 1.838a.305.305 0 0 1-.233-.5A4.37 4.37 0 0 1 5.725.761a.305.305 0 1 1-.306.528c-3-1.734-4.8.351-4.88.441a.3.3 0 0 1-.234.109",
    "data-name": "Path 51133"
  }))))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2919",
    d: "M10.665 23.201a1.094 1.094 0 1 1-1.094-1.094 1.094 1.094 0 0 1 1.094 1.094",
    "data-name": "Path 51134"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f2919",
    d: "M21.121 21.725a1.094 1.094 0 1 1-1.094-1.094 1.094 1.094 0 0 1 1.094 1.094",
    "data-name": "Path 51135"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58153",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58152"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__j)",
    "data-name": "Group 58151",
    transform: "translate(4.75 22.355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.488 1.909c.137-.554 1.229-.939 1.913-1.082a36 36 0 0 1 5.5-.826c1.468-.016 1.392.7 1.478 1.7.08.888.089 1.8-1.614 2.255a23 23 0 0 1-4.89.682c-1.358.034-1.856-.406-2.156-1a2.67 2.67 0 0 1-.228-1.733m-11.38.713a36 36 0 0 1 5.511-.71c.7-.049 1.855.022 2.138.518a2.7 2.7 0 0 1 .257 1.729c-.128.649-.49 1.208-1.8 1.547a23 23 0 0 1-4.893.683c-1.758.028-2-.851-2.17-1.727-.188-.986-.451-1.653.958-2.039",
    "data-name": "Path 51136"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#052c35",
    d: "M27.252 21.998a.43.43 0 0 0-.336-.067c-.271.037-.647.046-1.17.057-.2 0-.429.01-.679.017-.791.026-1.968.139-3.149.3-1.1.153-2.1.336-2.894.528a10.7 10.7 0 0 0-1.954.678 6 6 0 0 1-3.71.517 11 11 0 0 0-2.066-.117c-.816.033-1.827.131-2.924.285-1.18.164-2.344.378-3.114.569l-.661.171a12 12 0 0 1-1.134.263.43.43 0 0 0-.31.159.61.61 0 0 0-.044.474l.087.614c.045.323.257.383.517.46.218.063.446.328.646.744q.028.063.061.144c.21.528.6 1.511 3.119 1.35a30 30 0 0 0 2.174-.219 18.4 18.4 0 0 0 3.141-.692 2.54 2.54 0 0 0 1.537-1.812c.232-.61.431-1.137 1.029-1.221s.934.37 1.323.892a2.53 2.53 0 0 0 1.966 1.326 18.5 18.5 0 0 0 3.211-.194 30 30 0 0 0 2.153-.385c2.467-.535 2.571-1.59 2.627-2.156 0-.055.01-.106.017-.15a1.3 1.3 0 0 1 .425-.9c.218-.136.407-.254.361-.579l-.074-.53c0-.029-.008-.059-.011-.089a.6.6 0 0 0-.17-.44m-1.3 1.836.019.237c.087.958.029 1.724-1.534 2.142a20 20 0 0 1-2.359.464 23 23 0 0 1-2.507.215c-1.374.034-1.8-.43-2.061-.937a2.58 2.58 0 0 1-.221-1.658c.113-.449 1.029-.835 1.835-1 .963-.2 2.376-.483 3.633-.658a15 15 0 0 1 1.841-.166c1.249-.013 1.286.477 1.353 1.365m-12.582 1.01a2.58 2.58 0 0 1 .244 1.655c-.11.557-.4 1.121-1.725 1.464a23 23 0 0 1-2.474.48 20 20 0 0 1-2.394.2c-1.613.025-1.881-.695-2.063-1.639l-.045-.23c-.177-.875-.275-1.357.928-1.686a15 15 0 0 1 1.814-.344 56 56 0 0 1 3.675-.362c.82-.058 1.808.063 2.038.464",
    "data-name": "Path 51137"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58156",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58155"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__k)",
    "data-name": "Group 58154",
    transform: "translate(14.889 31.359)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3673a",
    d: "M.305.895a.3.3 0 0 1-.228-.5A1.77 1.77 0 0 1 1.944.129a.306.306 0 1 1-.177.585C.895.45.54.794.525.814a.3.3 0 0 1-.221.091",
    "data-name": "Path 51138"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58159",
    opacity: 0.37,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58158"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__l)",
    "data-name": "Group 58157",
    transform: "translate(13.681 29.579)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2a479",
    d: "M10.495 5.224s.187-.839-.885-.606-2.844 2.144-2.844 2.144a36.5 36.5 0 0 0-3.589-5.594C2.467.292 2.231.056 1.777.003 1.503-.029.719.191 1.264.981a18.6 18.6 0 0 1 2.051 3.776s-.4-.414-1.073.093a1.24 1.24 0 0 0-.373 1.119.91.91 0 0 0-.793.093.86.86 0 0 0-.373.886s-.792.279-.7.932a9.8 9.8 0 0 0 .883 2.065 9 9 0 0 0 2.851.061 9.2 9.2 0 0 0 3.962-1.574 12.1 12.1 0 0 1 2.792-3.209",
    "data-name": "Path 51139"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58162",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58161"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__m)",
    "data-name": "Group 58160",
    transform: "translate(19.529 43.483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "M12.889.18c.967.916 1.106 4.05 1.051 5.5a31.35 31.35 0 0 1-5.133 15.771c-4.2 6.043-10.328 2.656-8.458-3.078C1.481 14.9 3.901 13.888 6.493 5.44a9.06 9.06 0 0 1 2.748-4.274c.671-.528 3.012-1.594 3.649-.99",
    "data-name": "Path 51140"
  }))))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "M31.934 41.748a4.42 4.42 0 0 1 1.476 3.511c-.2 5.393-2.731 12.4-6.768 19.132-3.358 5.6-8.789 2.427-6.92-3.307 1.132-3.473 3.922-6.665 6.513-15.113a9.06 9.06 0 0 1 2.748-4.274 2.78 2.78 0 0 1 2.951.051",
    "data-name": "Path 51141"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58165",
    opacity: 0.22,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58164"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__n)",
    "data-name": "Group 58163",
    transform: "translate(19.738 49.224)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152429",
    d: "M5.402.005C3.169 6.065.981 8.849.002 11.818a31 31 0 0 0 .747 3.813c1.354 4.514 4.011.729 5.038-.408.847-.937 1.117-4.716.763-7.378A338 338 0 0 0 5.404.005",
    "data-name": "Path 51142"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58168",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58167"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#implicit_exercise_svg__o)",
    "data-name": "Group 58166",
    transform: "translate(9.189 64.346)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0d2528",
    d: "M19.978 5.879s.912-.461.643-1.171c-.228-.6-1.1-.346-1.1-.346s.7-.368.544-.993a.81.81 0 0 0-1.034-.533 24.4 24.4 0 0 1-5.979.53 21 21 0 0 1 1.36-2.128c.338-.415.4-.832.014-1.141-.425-.341-1.089.285-1.089.285a30 30 0 0 0-3.28 2.769l-.016-.164-.949.148a3 3 0 0 1-.006-.263L.003 2.226c.111 2.971.158 5.6.158 5.6l.09 2.267C4.267 9.78 9.62 8.906 9.62 8.906l-.023-.226.977-.08-.037-.386a20.6 20.6 0 0 0 3.586.73 10.5 10.5 0 0 0 5.025-.687c1.036-.483.708-1.05.708-1.05s.742-.346.6-.883a.55.55 0 0 0-.471-.441",
    "data-name": "Path 51143"
  }))))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8ad85",
    d: "M18.157 68.997a2.77 2.77 0 0 1 .789-2.209 25.5 25.5 0 0 1 3.576-3.106s.664-.626 1.089-.285c.384.308.324.725-.014 1.141a21 21 0 0 0-1.36 2.128 24.4 24.4 0 0 0 5.979-.53.813.813 0 0 1 1.034.533c.154.625-.544.993-.544.993s.876-.258 1.1.346c.269.71-.643 1.171-.643 1.171a.55.55 0 0 1 .47.441c.146.537-.595.883-.595.883s.328.567-.708 1.051a10.5 10.5 0 0 1-5.025.687 16.4 16.4 0 0 1-4.556-1.117c-.773-.551-.548-1.446-.6-2.127",
    "data-name": "Path 51144"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m18.004 66.478 1.221-.191.534 5.61-1.87.152Z",
    "data-name": "Path 51145"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "M18.271 66.172.564 64.913a9.55 9.55 0 0 0-.306 5.152c.83 2.533 3.687 3.445 6.869 3.435a106 106 0 0 0 11.678-1.3s-.572-5.61-.534-6.03",
    "data-name": "Path 51146"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd2b3",
    d: "M22.323 45.808s-1.1-4.842-.865-6.054c.434-2.258 3.262-4.475 3.262-4.475s.187-.839-.885-.605-2.844 2.144-2.844 2.144a36.5 36.5 0 0 0-3.589-5.594c-.71-.876-.946-1.112-1.4-1.165-.275-.032-1.058.188-.513.978a18.6 18.6 0 0 1 2.051 3.776s-.4-.414-1.073.093a1.24 1.24 0 0 0-.373 1.119.9.9 0 0 0-.792.093.86.86 0 0 0-.373.886s-.792.28-.7.932a14.3 14.3 0 0 0 1.725 3.5 4.04 4.04 0 0 0 2.19 1.585l.8 3.361Z",
    "data-name": "Path 51147"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8eaef",
    d: "M22.52 44.75a18 18 0 0 0-.407-2.137l-5.038 1.222.356 2.391Z",
    "data-name": "Path 51148"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#243f47",
    d: "m26.489 62.458-3.766-18.98-5.9 1.629s1.171 14.96 2.392 19.031c1.354 4.514 4.325 3.307 5.954 1.933 1.3-1.1 1.323-3.613 1.323-3.613",
    "data-name": "Path 51149"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58172"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4929",
    d: "M94 22h36a5 5 0 0 1 5 5v17a5 5 0 0 1-5 5h-27.323L94 54.813V49a5 5 0 0 1-5-5V27a5 5 0 0 1 5-5",
    "data-name": "Path 51088"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(112 41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11,
    y: 0
  }, "NO")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58173"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4929",
    d: "M5 0h36a5 5 0 0 1 5 5v17a5 5 0 0 1-5 5v7.092L30.909 27H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5",
    "data-name": "Path 51088"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 15,
    fontWeight: 500,
    transform: "translate(23 19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12,
    y: 0
  }, "YES"))))));
};
export default SvgImplicitExercise;